export default "__VITE_ASSET__CWtQexYW__"